module.exports = __webpack_public_path__ + "static/media/LogoPubMed.260107be.svg";